module.exports = __webpack_public_path__ + "media/05_ASANBUDAPEST-Atmosphere05.07861020.mp3";